import axiosInstance from '../../../../config/axiosInstance';
const  UserDefineService = {
    async GetAllKeyTypes(redirectCallback) {
        try {            
            const response = await axiosInstance.get(`/Setup/GetAllKeyTypes`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllUserDefineFields(ModuleID,redirectCallback) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetAllUserDefineFields?ModuleID=${ModuleID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async DeleteUserDefineFields(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteUserDefineFields?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
};

export default UserDefineService;